export const layoutPl = {
  sections: {
    sales: 'Sprzedaż',
    operations: 'Operacje',
    company: 'Firma',
    admin: 'Administracja',
  },
  /** Rozwijane grupy menu bocznego (`NAV_SECTIONS` w `app/layout/nav.ts`). */
  groups: {
    communication: 'Komunikacja',
    salesWork: 'Praca handlowa',
    supply: 'Zakupy i magazyn',
    team: 'Planer i czas pracy',
    finance: 'Finanse',
    insurance: 'Ubezpieczenia',
    insuranceDashboard: 'Pulpit ubezpieczeń',
    system: 'System',
    legal: 'Prawo i RODO',
  },
};

export const layoutEn: typeof layoutPl = {
  sections: {
    sales: 'Sales',
    operations: 'Operations',
    company: 'Company',
    admin: 'Administration',
  },
  groups: {
    communication: 'Communication',
    salesWork: 'Sales work',
    supply: 'Purchasing & warehouse',
    team: 'Planner & work time',
    finance: 'Finance',
    insurance: 'Insurance',
    insuranceDashboard: 'Insurance dashboard',
    system: 'System',
    legal: 'Legal & GDPR',
  },
};
